import { render, staticRenderFns } from "./schoolConstruction.vue?vue&type=template&id=f77bcb9c&scoped=true&"
import script from "./schoolConstruction.vue?vue&type=script&lang=js&"
export * from "./schoolConstruction.vue?vue&type=script&lang=js&"
import style0 from "./schoolConstruction.vue?vue&type=style&index=0&id=f77bcb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77bcb9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
